import enquire from 'enquire.js'

export default () => {
    const elFilterGroups = document.querySelectorAll('[data-filter-group]')

    const toggleGroup = (event) => {
        const elFilterGroup = event.target.closest('[data-filter-group]')

        if (
            event.type === 'keydown' &&
            event.keyCode !== 32 &&
            event.keyCode !== 13
        ) {
            return
        }

        if (elFilterGroup.dataset.state === 'closed') {
            elFilterGroup.dataset.state = 'open'
            event.target.setAttribute('aria-expanded', 'true')
            return
        }

        if (elFilterGroup.dataset.state === 'open') {
            elFilterGroup.dataset.state = 'closed'
            event.target.setAttribute('aria-expanded', 'false')
        }
    }

    enquire.register('screen and (max-width: 50em)', {
        setup() {
            Array.from(elFilterGroups).forEach((elFilterGroup) => {
                const elHeader = elFilterGroup.querySelector(
                    '[data-filter-group-toggle]'
                )
                elHeader.setAttribute('aria-role', 'button')
                elHeader.setAttribute('tabindex', '0')
                elHeader.setAttribute('aria-expanded', 'false')

                elFilterGroup.dataset.state = 'closed'
                elHeader.addEventListener('click', toggleGroup)
                elHeader.addEventListener('keydown', toggleGroup)
            })
        },

        // match() {
        //     Array.from(elFilterGroups).forEach((elFilterGroup) => {
        //         const elHeader = elFilterGroup.querySelector(
        //             '[data-filter-group-toggle]'
        //         )
        //         elHeader.setAttribute('aria-role', 'button')
        //         elHeader.setAttribute('tabindex', '0')
        //         elHeader.setAttribute('aria-expanded', 'false')

        //         elFilterGroup.dataset.state = 'closed'
        //         elHeader.addEventListener('click', toggleGroup)
        //         elHeader.addEventListener('keydown', toggleGroup)
        //     })
        // },
        // unmatch () {
        //     Array.from(elFilterGroups).forEach((elFilterGroup) => {
        //         const elHeader = elFilterGroup.querySelector('[data-filter-group-toggle]')

        //         elHeader.removeAttribute('aria-role')
        //         elHeader.removeAttribute('tabindex')
        //         elHeader.removeAttribute('aria-expanded')

        //         elFilterGroup.dataset.state = 'open'
        //         elHeader.removeEventListener('click', toggleGroup)
        //         elHeader.addEventListener('keydown', toggleGroup)
        //     })
        // },
    })
}
